import {Button, CircularProgress, Tooltip} from "@mui/material";
import {CloudDownload, Done} from "@mui/icons-material";
import {analyticsExportEvent} from "../../../services/analytics/AnalyticEvents";
import React, {useEffect, useState} from "react";
import {useStores} from "../../../stores";
import {observer} from "mobx-react-lite";
import {downloadAsFile} from "../../../components/download-data-button/DownloadAsFile";

export const DownloadReviewButtons: React.FC = observer(() => {
    const {bagStore, authStore, materializedApi, p, categorizationReviewStore} = useStores();
    const bagId = bagStore.bagId;
    const [isDownloadingExcel, setIsDownloadingExcel] = useState(false);
    const [hasDownloadedExcel, setHasDownloadedExcel] = useState(false);
    const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);
    const [hasDownloadedCsv, setHasDownloadedCsv] = useState(false);


    const statusDelegate = categorizationReviewStore.statusDelegate;
    const catIsBusy = statusDelegate.isFinal === false;
    const tooltipError = catIsBusy ? 'The AI module is still processing the data. Please try again later.' : '';

    useEffect(() => {
        // A bit hacky, but it works for now
        statusDelegate.checkStatus();
    }, [bagId, statusDelegate]);

    return <>
        {p.p.allowReviewDownloadExcel &&
            <Tooltip title={tooltipError}>
                <span>
                    <Button
                        color="primary"
                        variant="outlined"
                        className="btn-with-circular-progress button-spacing"
                        sx={{mt: '1em', mr: '1em'}}
                        startIcon={isDownloadingExcel
                            ? <CircularProgress size={14}/>
                            : (hasDownloadedExcel ? <Done/> : <CloudDownload/>)}
                        endIcon={isDownloadingExcel ? undefined : (hasDownloadedExcel ? undefined : undefined)}
                        disabled={isDownloadingExcel || catIsBusy}
                        onClick={() => {
                            setIsDownloadingExcel(true)
                            analyticsExportEvent({
                                export_type: 'categorization',
                                object_key: String(bagId),
                                user: authStore.email
                            })
                            const filename = (bagStore.bag?.name ?? bagId).toString() + '.xlsx';
                            materializedApi.downloadReviewExcel(bagId, filename)
                                .then(resp => {
                                    downloadAsFile(resp, filename);
                                    setHasDownloadedExcel(true)
                                })
                                .finally(() => {
                                    setIsDownloadingExcel(false)
                                })
                        }}>
                    {isDownloadingExcel ? 'Preparing data' : 'Download Excel file'}
                </Button>
                </span>
            </Tooltip>
        }
        {p.p.allowReviewDownloadCsv &&
            <Tooltip title={tooltipError}>
                <span>
                    <Button
                        color="primary"
                        variant="outlined"
                        className="btn-with-circular-progress button-spacing"
                        sx={{mt: '1em', mr: '1em'}}
                        startIcon={isDownloadingCsv ? <CircularProgress size={14}/> : (hasDownloadedCsv ?
                            <Done/> : <CloudDownload/>)}
                        endIcon={isDownloadingCsv ? undefined : (hasDownloadedCsv ? undefined : undefined)}
                        disabled={isDownloadingCsv || catIsBusy}
                        onClick={() => {
                            setIsDownloadingCsv(true)
                            analyticsExportEvent({
                                export_type: 'categorization',
                                object_key: String(bagId),
                                user: authStore.email
                            })
                            const filename = (bagStore.bag?.name ?? bagId).toString() + '.zip';
                            materializedApi.downloadReviewCsv(bagId, filename)
                                .then(resp => {
                                    downloadAsFile(resp, filename);
                                    setHasDownloadedCsv(true)
                                })
                                .finally(() => {
                                    setIsDownloadingCsv(false)
                                })
                        }}>
                {isDownloadingCsv ? 'Preparing data' : 'Download CSV file'}
            </Button>
                </span>
            </Tooltip>
        }


    </>
})